module.exports = __webpack_public_path__ + "static/logo-8f5b96e3f7dff98e896f8d8a9528c41d.jpg";